import {
  IonIcon,
  IonImg, IonText,
} from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import { ReactNode } from 'react';

import SuccessImage from '@/assets/imgs/success-modal-bg.webp';
import Button from '@/components/common/Button';

import styles from './SuccessModal.module.scss';

export interface SuccessModalProps {
  onDismiss: () => void;
  message: string | ReactNode;
  title?: string;
  srcImage?: string;
  modalSize: boolean;
  txtButton?: string;
  padding?: string;
}

export default function SuccessModal({
  onDismiss,
  message,
  srcImage = SuccessImage,
  modalSize = true,
  title = '¡Listo!',
  txtButton = 'Continúa',
  padding = '20px',
}: SuccessModalProps) {
  return (
    <div
      id="bottom-modal-success"
      className={`${styles.container} ${modalSize ? styles.modalSize : ''}`}
    >
      <div className={styles.closeButton}>
        <IonIcon
          id="button-close-success-modal"
          icon={closeOutline}
          onClick={onDismiss}
        />
      </div>
      <div style={padding ? { padding } : {}}>
        <IonImg
          src={srcImage}
          style={modalSize ? {
            display: 'block', width: '80%', margin: '0 auto', justifySelf: 'center', height: '80%',
          } : {}}
        />
        <div className={styles.infoContainer} style={!title ? { textAlign: 'center' } : {}}>
          <div className={styles.titleWrapper}>
            <IonText color="dark" className={styles.title}>
              {title}
            </IonText>
            {title === ''
              ? (
                <IonText color="dark" style={{ fontSize: '22px', fontWeight: '700' }}>
                  {message}
                </IonText>
              )
              : (
                <IonText color="medium">
                  {message}
                </IonText>
              )}
          </div>
          <Button
            id="button-modal-success"
            onClick={onDismiss}
          >
            {txtButton}
          </Button>
        </div>
      </div>
    </div>
  );
}
